<template>
    <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <router-link :to="`/${ $options.module }`" class="button button-back">
                    {{ $t('general.form.buttons.cancel') }}
                </router-link>
            </section>
            <section class="content-header-section">
                <button
                    type="button"
                    class="button button-gray"
                    @click="actionSave"
                >
                    {{ $t('general.form.buttons.save') }}
                </button>
            </section>
        </header>
        <div v-if="element" class="content-form pb-3">
            <input-text
                field="key"
                :element="element"
                :errors="errors"
                :label="$t(`pages.${ this.$options.module }.form.labels.key`)"
                :note="$t(`pages.${ this.$options.module }.form.notes.key`)"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.key`)"
                :maxlength="2"
            />
            <input-i18n
                field="name"
                :label="$t(`pages.${ this.$options.module }.form.labels.title`)"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.title`)"
                :locales="element.locales"
                :errors="errors"
                :currentLanguage="currentLanguage"
                @actionChangeLang="actionChangeLang"
                :maxlength="100"
            />
            <input-image
                field="flagimage"
                :element="element"
                :errors="errors"
                :label="$t(`pages.${ this.$options.module }.form.labels.flag`)"
                spec_dimm="recommended width 224px"
                spec_format="jpg or png"
            />
            <input-image
                field="moodimage"
                :element="element"
                :errors="errors"
                :label="$t(`pages.${ this.$options.module }.form.labels.impression`)"
                spec_dimm="exactly 1242 x 795 px"
                spec_format="jpg or png"
            />
            <input-i18n
                field="travelhintsurl"
                :label="$t(`pages.${ this.$options.module }.form.labels.travel_hints_url`)"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.travel_hints_url`)"
                :locales="element.locales"
                :errors="errors"
                :currentLanguage="currentLanguage"
                @actionChangeLang="actionChangeLang"
            />
            <input-one-checkbox
                v-model="element.isincrisis"
                :label="$t(`pages.${ this.$options.module }.form.labels.countryCrisis`)"
                :errors="errors"
                :option="crisisOption"
                @input="resetCrisisText"
            />
            <div v-if="editElement && editElement.isincrisis && editElement.id && element.isincrisis" class="form-input">
              <send-crisis-notification-button :countryId="editElement.id" />
            </div>
            <input-textarea
                v-if="element.isincrisis"
                field="crisistext"
                :label="$t(`pages.${ this.$options.module }.form.labels.crisisText`, [this.countryName])"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.crisisText`)"
                :subtext="$t(`pages.${ this.$options.module }.form.notes.crisisText`)"
                :locales="element.locales"
                :errors="errors"
                :currentLanguage="currentLanguage"
                @actionChangeLang="actionChangeLang"
            />
        </div>
        <pop-down
            v-if="pop.active"
            :class="pop.className"
            @close="popClose"
        >
            {{ pop.message }}
        </pop-down>
    </main>
</template>

<script>
import PopDownMixin from '@/components/PopDownMixin';
import FormMixin from '@/components/form/FormMixin';
import SendCrisisNotificationButton from '@/components/form/SendCrisisNotificationButton.vue';

export default {
    mixins: [FormMixin, PopDownMixin],
    name: 'CountriesForm',
    module: 'countries',
    components: {
        SendCrisisNotificationButton,
    },
    emptyElement: {
        key: '',
        isincrisis: false,
        locales: {
            de: {
                name: '',
                travelhintsurl: '',
                crisistext: 'Befinden Sie sich in der Krisenregion?',
            },
            it: {
                name: '',
                travelhintsurl: '',
                crisistext: 'Si trova nella regione in crisi?',
            },
            fr: {
                name: '',
                travelhintsurl: '',
                crisistext: 'Vous trouvez-vous dans la région en crise?',
            },
            en: {
                name: '',
                travelhintsurl: '',
                crisistext: 'Are you currently in the area affected by the crisis?',
            },
        },
    },
    computed: {
        crisisOption() {
            return {
                value: true,
                title: this.$t(`pages.${ this.$options.module }.form.labels.isinCrisis`),
            };
        },
        countryName() {
            return this.element.locales.en.name || 'country';
        },
    },
    methods: {
        resetCrisisText(value) {
            if (!value) {
                this.element.locales.en.crisistext = null;
                this.element.locales.fr.crisistext = null;
                this.element.locales.de.crisistext = null;
                this.element.locales.it.crisistext = null;
            }
        },
    },
};
</script>
